import * as React from 'react';
import Area from './Area';
import { Canvas, GroupProps, useFrame } from '@react-three/fiber';
import {
  ContactShadows,
  Mask,
  MeshDistortMaterial,
  OrbitControls,
  TransformControls,
  useMask,
} from '@react-three/drei';
import { Mesh } from 'three';
import Target from './Target';

function MaskedContent(props: GroupProps) {
  const stencil = useMask(1);
  const meshTorus = React.useRef<Mesh>(null);
  useFrame((state) => meshTorus.current && (meshTorus.current.rotation.y = -state.clock.elapsedTime / 2));
  return (
    <group {...props}>
      <mesh position={[-0.75, 0, 0]} scale={1} ref={meshTorus}>
        <torusKnotGeometry args={[0.6, 0.2, 128, 64]} />
        <meshNormalMaterial {...stencil} />
      </mesh>
      <mesh position={[0.75, 0, 0]}>
        <sphereGeometry args={[0.8, 64, 64]} />
        <meshStandardMaterial {...stencil} color={'white'} />
      </mesh>
    </group>
  );
}

export type Props = {};

function App02(props: Props) {
  const {} = props;

  return (
    <Area>
      <Canvas camera={{ position: [0, 3, 10], fov: 50 }} gl={{ stencil: true }}>
        <hemisphereLight intensity={1} groundColor={'red'} />
        <ContactShadows frames={1} scale={10} position={[0, -1, 0]} blur={8} opacity={0.55} />
        <OrbitControls makeDefault position={[0, 10, 10]} />

        <React.Suspense>
          <TransformControls position={[0, 0, 0]}>
            <Mask id={1}>
              <planeGeometry args={[2, 2, 128, 128]} />
              <MeshDistortMaterial distort={0.5} radius={1} speed={2} />
            </Mask>
          </TransformControls>
          {/* <Float floatIntensity={5} rotationIntensity={2} speed={10}>
            <Mask id={1} position={[-1.1, 0, 0]}>
              <ringGeometry args={[0.5, 1, 64]} />
            </Mask>
          </Float> */}
          <mesh>
            <planeGeometry args={[2, 2, 128, 128]} />
            <MeshDistortMaterial distort={0.5} radius={1} speed={2} />
          </mesh>

          <MaskedContent />
          <Target position={[0, -1, -3]} scale={1.5} />
          <axesHelper />
          <gridHelper />
        </React.Suspense>
      </Canvas>
    </Area>
  );
}

export default React.memo(App02);
